class AddOnDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#AddOnDrawer-Overlay').addEventListener('click', this.close.bind(this));

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.alert = this.querySelector('.alert');

    this.addOnButton = document.querySelector('#AddOnButton');
    if (this.addOnButton) this.addOnButton.addEventListener('click', this.open.bind(this));

    this.checkboxes = this.querySelectorAll('.add-on-checkbox');
    if (this.checkboxes.length) {
      this.checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', this.calculateAddOns.bind(this));
      });
    }

    this.quantityInputs = this.querySelectorAll('.quantity__input');
    if (this.quantityInputs.length) {
      this.quantityInputs.forEach(input => {
        input.addEventListener('change', this.calculateAddOns.bind(this));
      });
    }

    this.variantButtons = this.querySelectorAll('.variant-btn');
    if (this.variantButtons.length) {
      this.variantButtons.forEach(variant_button => {
        variant_button.addEventListener('click', this.variantChange.bind(this));
      });
    }

    this.optionButtons = this.querySelectorAll('.option-button');
    if (this.optionButtons.length) {
      this.optionButtons.forEach(button => {
        button.addEventListener('click', this.optionBtnClick.bind(this));
      });
    }

    this.submitButton = this.querySelector('.add-on-form__submit');
    this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));

  }

  optionBtnClick(e) {

    var target = e.target.closest('button') || e;

    var closest_product = target.closest('.add-on-product')
    var details = closest_product.querySelector('details');

    details.open ? details.open = false : details.open = true;

  }

  variantChange(e) {

    var variant = e.target.closest('.variant');
    var variant_button = e.target.closest('.variant-btn');

    var id = variant.dataset.varId;
    var price = variant.dataset.varPrice;
    var image = variant.dataset.varFeaturedImage;

    var product = variant.closest('.add-on-product');
    var name_holder = product.querySelector('.variant-name-holder');
    var price_holder = product.querySelector('.add-on-price-regular');
    var checkbox = product.querySelector('.add-on-checkbox');
    var product_images = product.querySelectorAll('.image .square');

    var all_variants = variant.closest('.grid').querySelectorAll('.variant-btn');
    all_variants.forEach(variant => {
      variant.classList.remove('active');
    });

    name_holder.innerText = variant_button.innerText;
    variant_button.classList.add('active');
    price_holder.innerText = Shopify.formatMoney(parseInt(price), Shopify.money_format);

    if (image) {
      product_images.forEach(product_image => {
        if (product_image.dataset.varId == id) {
          product_image.classList.add('active');
        } else {
          product_image.classList.remove('active');
        }
      })
    }

    checkbox.checked = true;
    checkbox.dataset.price = price;
    checkbox.dataset.variantId = id

    // this.calculateAddOns(checkbox);

  }

  calculateAddOns(e) {

    var target = e.target || e;

    var total_price = this.querySelector('.total-price');
    this.basePrice = total_price.dataset.price;

    this.addOnItems = {
      addOnTotal: 0,
      items: [],
      items_to_add: []
    };

    this.quantityInputs.forEach(input => {

      var value = input.value;
      var checkbox = input.closest('.add-on-product').querySelector('.checkbox-round.add-on-checkbox');

      console.log('checkbox', checkbox)

      if (value > 0) {
        var data = {
          title: checkbox.value,
          price: (parseFloat(checkbox.dataset.price) * value)
        };
        var item = {
          id: parseInt(checkbox.dataset.variantId),
          quantity: value
        };

        this.addOnItems.items.push(data);
        this.addOnItems.items_to_add.push(item);
      }
    });


    console.log("Added", this.addOnItems)

    var add_on_total = this.addOnItems.items.map(item => item.price).reduce((partialSum, a) => partialSum + a, 0);
    total_price.innerHTML = Shopify.formatMoney(add_on_total, Shopify.money_format);

    var items_to_add = this.addOnItems.items_to_add
    return items_to_add;
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.add-on-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    var item_data = this.calculateAddOns(evt);
    if (!item_data.length){
      this.alert.classList.remove('hidden')
      return;
    } else {
      this.alert.classList.add('hidden')
    };

    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    const config = fetchConfig('javascript');
    delete config.headers['Accepts'];

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    var formData = {
      'sections': this.cart.getSectionsToRender().map((section) => section.id).join(),
      'sections_url': window.location.pathname,
      'items': item_data
    };

    config.body = JSON.stringify(formData);

    console.log(config);

    // return

    fetch(`${routes.cart_add_url}.js`, config)
      .then((response) => response.json())
      .then((response) => {

        console.log(response);

        if (response.status) {
          // publish(PUB_SUB_EVENTS.cartError, {
          //   source: 'product-form',
          //   productVariantId: formData.get('id'),
          //   errors: response.description,
          //   message: response.message,
          // });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          // publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }

        if (!response.status) {
          this.close()
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');

      });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    // removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble-desktop'
      },
      {
        id: 'cart-icon-bubble-mobile'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('add-on-drawer', AddOnDrawer);


